import { render, staticRenderFns } from "./DisengagedEmployees.vue?vue&type=template&id=6f5a1c3a&scoped=true"
import script from "./DisengagedEmployees.vue?vue&type=script&lang=js"
export * from "./DisengagedEmployees.vue?vue&type=script&lang=js"
import style0 from "./DisengagedEmployees.vue?vue&type=style&index=0&id=6f5a1c3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5a1c3a",
  null
  
)

export default component.exports